import { watch, ref, onUpdated } from '@vue/composition-api'
import store from '@/store'
import tools from '@/sag-core/tools'

export default function(props, emit){
    const isToggle = ref(false)

    const toggle = (p, q)=>{
        // p: display boolean
        if(isToggle.value === !p){
            emit('displayEvent', p)
        }
        isToggle.value = p
        
        // q: submit boolean
        if(q === true){
            emit('submitEvent')
        }
    }
    
    const refreshOverlay = (isToggle)=>{
        const cls = document.querySelector(`.overlay-${props.name}`)
        if(cls)
            isToggle ? cls.classList.add('show') : cls.classList.remove('show')
    }

    const watchToggle = watch(
        ()=>isToggle.value,
        (isToggle, preIsToggle)=>{
                refreshOverlay(isToggle)
            }
    )
    
    refreshOverlay(isToggle.value)

    // 拋出toggle事件
    emit('btnClick', toggle)

    return {
        isToggle,
        toggle
    }
}